<template>
  <b-row class="m-0">
    <b-col lg="6" md="12" v-if="period_context_loaded" class="px-2 pb-4">
      <b-container fluid class="white-box">
        <highcharts :options="chartOptionsLeft"></highcharts>
        <no-data v-if="pie_data_states.length < 1"/>
      </b-container>
    </b-col>
    <b-col v-else lg="6" md="12" class="px-2 pb-4">
      <loader-box height="408px"/>
    </b-col>

    <b-col lg="6" md="12" v-if="period_context_loaded" class="px-2 pb-4">
      <b-container v-if="!is_marketplace" fluid class="white-box">
        <highcharts :options="chartOptionsRight"></highcharts>
        <no-data v-if="pie_data_devices.length < 1"/>

        <b-row v-if="pie_data_devices.length > 1" class="offset-icons align-items-center">
          <b-col style="max-width: fit-content;" class="p-0 pr-3 pl-2">
            <img src="@/assets/period/mobile_icon.svg" alt="mobile_icon">
          </b-col>
          <b-col style="max-width: fit-content;" class="text-base">
            <b-row class="text-16">{{ mobile_percentage }}</b-row>
            <b-row class="text-12">mobile</b-row>
          </b-col>
          <b-col style="max-width: fit-content;" class="p-0 pr-3 pl-2">
            <img src="@/assets/period/desktop_icon.svg" alt="desktop_icon">
          </b-col>
          <b-col style="max-width: fit-content;" class="text-base p-0 pr-3 pl-2">
            <b-row class="text-16">{{ desktop_percentage }}</b-row>
            <b-row class="text-12">desktop</b-row>
          </b-col>
        </b-row>
      </b-container>
      <b-container v-else fluid class="white-box" style="height: 100%;">
        <b-row class="text-base two-d-center">Indisponível para marketplace :(</b-row>
      </b-container>
    </b-col>
    <b-col v-else lg="6" md="12" class="px-2 pb-4">
      <loader-box height="408px"/>
    </b-col>
  </b-row>
</template>

<script>
import Highcharts from 'highcharts'

import LoaderBox from '@/components/LoaderBox.vue'
import NoData from '@/components/NoData.vue'

export default {
  components: {
    LoaderBox,
    NoData,
  },
  computed: {
    period_context_loaded() { return this.$store.getters.period_context_loaded },
    is_marketplace() { return this.$store.getters.is_marketplace },
    pie_data_states() { return this.$store.getters.pie_data_states },
    pie_data_devices() { return this.$store.getters.pie_data_devices },
    mobile_percentage() { return this.$store.getters.mobile_percentage },
    desktop_percentage() { return this.$store.getters.desktop_percentage },
    chartOptionsLeft() {
      const DATA = this.pie_data_states;
      return {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        title: {
          text: '5 estados com mais vendas:'
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.2f}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              distance: -50,
              style: {
                color: 'white',
                textOutline: 'none'
              },
              formatter: function() {
                return Highcharts.numberFormat(this.percentage, 0) + '%'
              }
            },
            showInLegend: true
          }
        },
        series: [{
          name: 'Vendas',
          colorByPoint: true,
          data: DATA
        }],
      }
    },
    chartOptionsRight() {
      const DATA = this.pie_data_devices;
      return {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        title: {
          text: '5 dispositivos mais usados:'
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.2f}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              distance: -50,
              style: {
                color: 'white',
                textOutline: 'none'
              },
              formatter: function() {
                return Highcharts.numberFormat(this.percentage, 0) + '%'
              }
            },
            showInLegend: true
          }
        },
        series: [{
          name: 'Usos',
          colorByPoint: true,
          data: DATA
        }],
      }
    }
  }
}
</script>

<style scoped>
  @media only screen and (min-width: 576px) {
    .offset-icons {
      position: relative;
      height: 0;
      top: -110px;
      left: -5%;
      float: right;
    }
  }

  @media only screen and (max-width: 576px) {
    .offset-icons {
      position: relative;
      justify-content: center;
      margin-bottom: 1rem;
      margin-top: 1rem;
    }
  }
</style>
